<template>
  <div
    :class="post.can_be_blurred && post.user[0].id !== authUser.user.id ? 'blur position-relative' : 'position-relative'"
    :style="{
      'box-shadow': post.sponsered.length ? '0 0 15px rgb(0,0,0,0.1)' : 'none',
      'border-radius': '8px',
    }"
    @click="handleCloseAll"
  >
    <div v-if="post.sponsered.length" class="promoted-post-head" :style="{ background: getAlphaPrimaryColor() }">
      <div>
        <svg class="megaphone" :style="{ color: getPrimaryColor() }"></svg>
      </div>
      <div class="promoted-text ml-1" :style="{ color: getPrimaryColor() }">
        PROMOTED
      </div>
    </div>
    <div
      class="shadow-card"
      :style="{
        background:
          post.user[0].role === 'doctor' || post.user[0].role === 'ohcp'
            ? ' #F8FEFF'
            : post.user[0].role === 'admin'
            ? '#EBFCF5'
            : post.user[0].role === 'nfp_administrator' || post.user[0].role === 'hospital_administrator'
            ? '#FFFCF5'
            : '#ffffff',
        'border-radius': post.sponsered.length ? '0px' : '8px',
        'border-bottom-left-radius': '8px',
        'border-bottom-right-radius': '8px',
        'box-shadow': post.sponsered.length ? 'none' : '0 0 15px rgb(0,0,0,0.1)',
      }"
    >
      <div class="post-head position-relative mb-2">
        <div class="title cp" @click="viewProfile">
          <a @click="viewProfile">
            <!-- <a-avatar
                icon="user"
                :src="
                  post.sponsered.length ? post.sponsered[0].url : post.user[0].url
                "
                alt
                :size="84"
                class="post-list-image"
              /> -->
            <a-avatar
              :style="{
                color: '#ffffff',
                'background-color': (post.sponsered.length ? post.sponsered[0].url : post.user[0].url) ? '' : '#C997C5',
              }"
              :size="70"
              class="post-list-image text-capitalize"
              :src="post.sponsered.length ? post.sponsered[0].url : post.user[0].url"
            >
              <!-- {{
                  post.sponsered.length
                    ? post.sponsered[0].name[0]
                    : post.user[0].role === "doctor"
                    ? post.user[0].first_name[0]
                    : post.user[0].display_name[0]
                }} -->
              {{
                post.sponsered && post.sponsered.length
                  ? post.sponsered[0].name[0]
                  : post.user[0].first_name
                  ? post.user[0].first_name[0].toUpperCase() + ((post.user[0].last_name && post.user[0].last_name[0].toUpperCase()) || "")
                  : post.user[0].display_name[0].toUpperCase()
              }}
            </a-avatar>
          </a>
        </div>
        <div class="my-auto cp" @click="viewProfile">
          <div v-if="post.sponsered.length">
            <p class="m-0 pb-0 pt-2 pl-0 cp">
              {{ post.sponsered[0].name.charAt(0).toUpperCase() + post.sponsered[0].name.slice(1) }}
            </p>
          </div>
          <template v-else>
            <div class="d-flex align-items-center">
              <p class="m-0 p-0 cp text-capitalize" @click="viewProfile" v-if="post.user[0].role === 'patient'">
                <!-- {{
                    post.user[0].first_name
                      ? post.user[0].first_name + " " + post.user[0].last_name
                      : post.user[0].display_name
                  }} -->
                {{ post.user[0].display_name }}
              </p>
              <p
                class="m-0 pb-0 pt-2 pl-0 cp text-capitalize"
                @click="viewProfile"
                v-if="post.user[0].role === 'hospital_administrator' || post.user[0].role === 'clinic_administrator' || post.user[0].role === 'nfp_administrator'"
              >
                {{ post.user[0].display_name }}
              </p>
              <p class="m-0 pb-0 pt-0 pl-0 cp text-capitalize" @click="viewProfile" v-if="post.user[0].role === 'advocate'">
                <!-- {{
                    post.user[0].display_name.charAt(0).toUpperCase() +
                      post.user[0].display_name.slice(1)
                  }} -->
                {{ post.user[0].first_name ? post.user[0].first_name + " " + post.user[0].last_name : post.user[0].display_name }}
              </p>
              <p class="m-0 pb-0 pt-2 pl-0 cp text-capitalize" @click="viewProfile" v-if="post.user[0].role === 'admin'">
                {{ post.user[0].display_name.charAt(0).toUpperCase() + post.user[0].display_name.slice(1) || "DoveMed Admin" }}
              </p>
              <p class="m-0 p-0 cp text-capitalize" @click="viewProfile" v-if="post.user[0].role === 'caregiver'">
                {{ post.user[0].display_name.charAt(0).toUpperCase() + post.user[0].display_name.slice(1) }}'s patient
              </p>
              <p class="m-0 pb-0 pl-0 pt-0 cp text-capitalize" @click="viewProfile" v-if="post.user[0].role === 'doctor'">
                {{ "Dr. " + post.user[0].first_name.charAt(0).toUpperCase() + post.user[0].first_name.slice(1) }}
                {{ post.user[0].last_name }}
              </p>
              <p
                class="m-0 p-0 sub-text ml-2"
                style="font-weight: 400"
                v-if="
                  post.day_type &&
                    post.user_role !== 'clinic_administrator' &&
                    post.user_role !== 'doctor' &&
                    post.user_role !== 'advocate' &&
                    post.user_role !== 'nfp' &&
                    post.user_role !== 'hcp' &&
                    post.user_role !== 'hospital_administrator'
                "
              >
                was feeling {{ getPostEmoji }}
              </p>
            </div>

            <!-- ROLE TAGS -->
            <div
              class="
                  post-physician
                  py-1
                  px-2
                  turquoise-text turquoise-bg
                  font12
                "
              v-if="post.user[0].role === 'admin'"
            >
              DoveMed Admin
            </div>
            <div class="py-1" v-if="post.user[0].role === 'hospital_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
                Hospital
              </span>
              <span class="font12 pl-1"> {{ post.user[0].speciality }} </span>
            </div>
            <div class="pt-1 pr-2 pl-0" v-if="post.user[0].role === 'doctor' || post.user[0].role === 'physician'">
              <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
                Physician
              </span>
              <span class="font12 pl-1"> {{ post.user[0].speciality }} </span>
            </div>
            <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="post.user[0].role === 'nfp'">
              Non For Profit
            </div>
            <div class="post-physician py-1 px-2 orange-bg orange-text font12" v-if="post.user[0].role === 'advocate'">
              <div v-if="post.user[0].organization">Supporting ({{ post.user[0].organization }})</div>
              <div v-else class="orange-text font12">
                <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
                Advocate for
                {{ currentCircle.condition_type.slice(0, 20) }}
                {{ currentCircle.condition_type.length > 20 ? "..." : "" }}
              </div>
            </div>

            <!-- <i
                v-if="post.post_location && post.post_location.city"
                class="fa fa-map-marker"
                aria-hidden="true"
                :style="{ color: '#777' }"
                >&nbsp;{{ post.post_location.city }},
                {{ post.post_location.state }}</i
              > -->
            <!-- <div
                :style="{ color: '#777 !important' }"
                v-if="post.post_location && post.post_location.country"
              >
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{ post.post_location.country }}, {{ post.post_location.state }}.
              </div> -->
          </template>
          <p class="posted mt-1">{{ formatPostTime(post.post_time) }}</p>
        </div>

        <!-- MENU FOR OTHERS POSTS -->
        <button v-if="!post.admin_unflagged && post.user[0].id !== authUser.user.id" class="threedot-menu cp">
          <div class="dot-menu-cont" @click="fetchUser">
            <font-awesome-icon size="1x" class="gray400 h16" :icon="['far', 'ellipsis-v']" />
          </div>
          <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
            <p class="card-item" @click="savePost">
              <font-awesome-icon size="1x" :icon="postSaved ? ['fas', 'bookmark'] : ['fal', 'bookmark']" class="mr-2 width30" />
              Save
            </p>
            <p class="card-item" @click="showModel(post)">
              <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 width30" />
              Report Post
            </p>
            <hr class="my-0" />
            <p class="card-item">
              <font-awesome-icon size="1x" :icon="['fal', 'comment-alt-slash']" class="mr-2 width30" />
              Mute User
            </p>
            <p v-if="showRemoveCircleOption" class="card-item" @click="() => $refs.removeUserModal.show(post.user[0])">
              Remove from Circle
            </p>
          </div>
        </button>

        <!-- MENU FOR SELF POSTS -->
        <button v-if="!post.admin_unflagged && post.user[0].id === authUser.user.id && post.user_role !== 'admin'" class="threedot-menu cp">
          <div class="dot-menu-cont" @click="fetchUser">
            <font-awesome-icon size="1x" class="gray400 h16" :icon="['far', 'ellipsis-v']" />
          </div>
          <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
            <p class="card-item" @click="e => handleDeletePostModal(e, post)">
              <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
              Delete Post
            </p>
            <p
              class="card-item"
              @click="
                () => {
                  $refs.EditPost.show(post)
                }
              "
            >
              <font-awesome-icon size="1x" :icon="['fal', 'pen']" class="mr-2" />
              Edit Post
            </p>
          </div>
        </button>

        <!-- <div
            class="delete-post-dropdown cp"
            v-if="
              !post.admin_unflagged &&
                post.user[0].id === authUser.user.id &&
                post.user_role !== 'admin'
            "
          >
            <a-dropdown placement="bottomRight" :trigger="['click']">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <div>
                  <font-awesome-icon
                    size="1x"
                    :style="{
                      color: '#94A3B8'
                    }"
                    :icon="['far', 'ellipsis-v']"
                  />
                </div>
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="0">
                  <span
                    class="dropdown-text"
                    @click="e => handleDeletePostModal(e, post)"
                  >
                    <font-awesome-icon
                      size="1x"
                      :icon="['fal', 'trash']"
                      class="mr-2"
                    />
                    Delete Post
                  </span>
                </a-menu-item>
                <a-menu-item key="1">
                  <span class="dropdown-text">
                    <font-awesome-icon
                      size="1x"
                      :icon="['fal', 'pen']"
                      class="mr-2"
                    />
                    Edit Post
                  </span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div> -->
      </div>

      <!-- <p style="white-space: pre-wrap">{{ post.post_text }}</p> -->
      <div class="post-image" v-if="post.thumbnail_url && post.thumbnail_url.length > 0">
        <img
          :src="post.thumbnail_url[0]"
          :style="{
            width: '100%',
            height: '100%',
            'object-fit': 'cover',
            'margin-top': '14px',
          }"
          alt
          class="mb-3"
        />
      </div>
      <div class="post-image" v-else-if="post.post_attach_url && post.post_attach_url.length > 0">
        <img
          :src="post.post_attach_url[0]"
          :style="{
            width: '100%',
            height: '100%',
            'object-fit': 'cover',
            'margin-top': '14px',
          }"
          alt
          class="mb-3"
        />
      </div>
      <p class="mb-2">
        <b>{{ post.post_title }}</b>
      </p>
      <p :style="{ 'white-space': 'pre-wrap', 'margin-left': '-15px' }" class="content ql-editor post-description" v-html="post.post_text"></p>

      <!-- <p class="posted">Posted {{ formatPostTime(post.post_time) }}</p> -->
      <!-- tags -->
      <div v-if="post.tags" class="post__tags">
        <div
          v-for="(tag, index) in post.tags.slice(0, 3)"
          :key="index"
          class="tags rounded"
          :style="{
            color: getSecondaryColor(),
            background: getAlphaPrimaryColor(),
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="post.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in post.tags.slice(3)"
                :key="index"
                :style="{
                  color: getSecondaryColor(),
                  background: getAlphaPrimaryColor(),
                }"
                class="rounded p-1"
              >
                #{{ tag }}
              </p>
            </template>
            <button
              :style="{
                background: getAlphaPrimaryColor(),
                color: getSecondaryColor(),
                'font-size': '10px',
                'line-height': '20px',
              }"
              class="rounded"
            >
              +{{ post.tags.length - 3 }}
            </button>
          </a-popover>
        </div>
      </div>

      <!-- ================================================================================================================ -->

      <!-- like comment share etc..... -->
      <div class="d-flex" :style="{ gap: '50px' }">
        <!-- EMBRACE -->
        <!-- <div id="hugs" class="u-options" @click="react(post, $event)">
            <font-awesome-icon
              size="1x"
              :icon="
                reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
              "
              :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
            />
            <div class="posted-reactions-text">
              Embrace ({{ post.reaction.hugs }})
            </div>
          </div> -->
        <!-- LIKES -->
        <div id="likes" class="u-options showReactions" :style="{ 'align-items': 'center' }">
          <!-- @click="react(post, $event)" -->
          <!-- <font-awesome-icon
              size="1x"
              :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
              :style="{width:'20.2px',height:'20px' , color: reactions.likes ? getPrimaryColor() : '' }"
            /> -->
          <font-awesome-icon
            v-if="!currentClickedReaction"
            size="1x"
            :icon="['fal', 'heart']"
            :style="{
              color: reactions.likes ? getPrimaryColor() : '',
              height: '20px',
              width: '17.5px',
              'margin-right': '1px',
            }"
          />
          <img v-else :src="require(`../../../assets/emojis/${currentClickedReaction}-40.png`)" class="hw20" alt="emoji" :style="{ transform: 'translateY(-1.5px)' }" />
          <div class="posted-reactions-text ml-0 text-capitalize">
            {{ currentClickedReaction || "Like" }}
          </div>

          <!-- emoji reactions on hover -->
          <div class="emojiReactions" @click="react(post, $event)">
            <emoji-reactions :handleClick="handleReactionsClick" />
          </div>

          <!-- ================================================================================================================ -->
        </div>
        <!-- COMMENTS -->
        <div
          class="u-options"
          :style="{
            display: !post.allow_comments ? 'none' : 'flex',
            cursor: 'default',
          }"
        >
          <!-- @click="comments.length === 0 && fetchComments(true, 5)" -->
          <font-awesome-icon size="1x" :style="{ height: '20px' }" :icon="['fal', 'comment-alt']" />
          <div class="posted-reactions-text">
            {{ post.comments_count }}
            {{ post.comments_count > 1 ? "Comments" : "Comment" }}
            <!-- Comment ({{ post.comments_count }}) -->
          </div>
        </div>
        <!-- BOOKMARKS -->
        <!-- <div id="favorites" :style="{'align-items':'center'}" class="u-options" @click="react(post, $event)">
            <font-awesome-icon
              size="1x"
              :icon="
                reactions.favorites ? ['fas', 'bookmark'] : ['fal', 'bookmark']
              "
              :style="{width:'15px',height:'20px', color: reactions.favorites ? getPrimaryColor() : '' }"
            />
            <div class="posted-reactions-text">Bookmark</div>
          </div> -->
        <!-- SHARE -->
        <div class="u-options" @click="() => $refs.sharePostModal.show(post, 1)">
          <!-- <font-awesome-icon
              size="1x"
              :icon="['fal', 'share']"
              :style="{ transform: 'scale(1.2)' }"
            /> -->
          <!-- <img
              src="../../assets/images/share.png"
              :style="{ width: '20px', height: '15px' }"
              alt="share"
            /> -->
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 2px">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          <div class="posted-reactions-text">Share</div>
        </div>

        <div @click="() => $refs.Reactions.show()" class="u-options ml-auto d-flex align-items-center flex-row-reverse">
          <span class="ml-2">
            {{ getTotalReactions() }}
          </span>
          <img v-for="emoji in getTopThreeReactions()" :key="emoji" :src="require(`../../../assets/emojis/${emoji}-40.png`)" alt="emoji" class="hw20" />
          <reactions ref="Reactions" :postProp="post" :key="posting" />
        </div>
      </div>

      <!-- ===================================================================================================================== -->

      <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
          Loading image...
        </div>
      </div>
      <div v-if="fileList.length > 0" class="image-uploading">
        <!-- Image Upload -->

        <a-upload v-if="fileList.length > 0" listType="picture-card" class="position-relative avatar-uploader" :fileList="fileList" @preview="handlePreview" @change="handleChange"></a-upload>
        <a-icon @click="handleChange({ file: fileList, fileList: [] })" :style="{ color: 'red', left: '48px', position: 'absolute' }" type="close-circle" theme="filled" />
      </div>
      <!-- <hr v-if="showWritable && post.comments_count" /> -->

      <!-- COMMENTS -->
      <div v-if="comments.length">
        <span
          v-if="comments.length != pagination.total_count"
          @click="fetchComments(true, 5)"
          :style="{
            color: getPrimaryColor(),
            textAlign: 'left',
            display: 'block',
            cursor: 'pointer',
            'font-size': '14px',
          }"
        >
          <hr />
          See latest comments
          <!-- <hr> -->
        </span>
        <div v-for="(comment, index) in comments" :key="index">
          <hr />
          <Comment :commentData="comment" :parentUserData="post.user[0]" :postComment="postComment" :removeCommentFromDisplay="removeCommentFromDisplay"></Comment>
          <!-- <hr /> -->
        </div>
      </div>

      <hr v-if="showWritable && post.allow_comments" />
      <!-- COMMENT TEXT EDITOR -->
      <div class="d-flex" v-if="post.allow_comments">
        <div
          v-if="showWritable"
          style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          class="post-comment mt-2"
        >
          <div class="title d-flex align-items-center mr-2" :style="{ 'font-size': '16px' }">
            <!-- <img :src="authUser.user.url" alt class="post-comment-image" /> -->
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#C997C5',
              }"
              :src="authUser.user.url"
              class="text-capitalize"
              :size="40"
            >
              <!-- {{
                  authUser.user.firstName
                    ? authUser.user.firstName[0]
                    : authUser.user.display_name
                    ? authUser.user.display_name[0]
                    : authUser.user.first_name[0]
                }} -->
              {{ getInitials() }}
            </a-avatar>
          </div>
          <a-input placeholder="Add a comment..." :disabled="!post.allow_comments" v-model="comment" @keyup.enter="postComment()" style="padding-right: 185px; color: black !important" />

          <div class="d-flex align-items-center position-relative cp">
            <font-awesome-icon
              size="1x"
              class="position-absolute"
              :style="{
                right: '130px',
                // top: '5px',
                transform: 'scale(0.6)',
              }"
              :icon="['fal', 'camera']"
            />
            <input
              class="camera-icon-inp position-absolute"
              type="file"
              accept="image/png, image/jpeg, image/gif, image/svg+xml"
              ref="fileInput"
              @change="handlePicUpload()"
              :style="{
                right: '130px',
                top: '-20px',
              }"
            />
          </div>
          <span
            class="position-absolute"
            :style="{
              display: 'flex',
              'align-self': 'center',
              'z-index': '10',
              right: '16px',
            }"
          >
            <!-- <div class="send-icon">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="paper-plane-top"
                  class="svg-inline--fa fa-paper-plane-top"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    :fill="currentCircle.color_code"
                    d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"
                  ></path>
                </svg>
              </div> -->
            <span class="cp" :style="{ transform: 'scale(0.75)' }" ref="BlackEmojiPicker">
              <BlackEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" />
            </span>
            <div class="my-auto cp font14 fw700" :style="{ color: getPrimaryColor(), 'margin-left': '8px' }" @click="postComment()">
              Comment
            </div>
          </span>
        </div>
      </div>
    </div>
    <ReportContentModal ref="reportContentModal" />
    <RemoveUserModal ref="removeUserModal" v-on:hideDots="displayDots = false" />
    <SharePostModal ref="sharePostModal" />
    <DeletePostModal ref="deletePostModal" />
    <EditPost ref="EditPost" />
    <div v-if="loadingScreen || posting" class="spinnerContainer-post">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import Comment from "../../home/Comment.vue"
import ReportContentModal from "../../Modals/ReportContent"
import RemoveUserModal from "../../Modals/RemoveUser"
import SharePostModal from "../../Modals/SharePost"
import VEmojiPicker from "v-emoji-picker"
import EmojiPicker from "vue-emoji-picker"
import packData from "v-emoji-picker/data/emojis.json"
import s3Upload from "../../../utilities/imageUploader"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { eventBus } from "../../../main"
import DeletePostModal from "../../Modals/deletePostModal.vue"
import EditPost from "../../Modals/EditPost.vue"

import { faEllipsisV, faHeart, faShare, faBookmark, faHandHoldingHeart, faHandsheart } from "@fortawesome/free-solid-svg-icons"
import { faHandsHeart } from "@fortawesome/pro-solid-svg-icons"
import { faHospitalAlt } from "@fortawesome/pro-regular-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCamera, faPen, faTrash } from "@fortawesome/pro-light-svg-icons"
import AllCirclesVue from "../../App/circle/AllCircles.vue"
library.add(faHeart, faShare, faBookmark, faHandHoldingHeart, faHandsHeart, faCamera, faEllipsisV, faPen, faTrash, faHospitalAlt)

import Reactions from "../../Modals/activity/Reactions.vue"
import EmojiReactions from "../../commons/EmojiReactions.vue"
import BlackEmojiPicker from "./../../../components/home/BlackEmojiPicker.vue"

const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "PostDoctor",
  components: {
    Comment,
    ReportContentModal,
    RemoveUserModal,
    VEmojiPicker,
    EmojiPicker,
    SharePostModal,
    DeletePostModal,
    Reactions,
    EmojiReactions,
    BlackEmojiPicker,
    EditPost,
  },
  props: {
    postData: Object,
  },

  computed: {
    getPostEmoji() {
      if (this.post.day_type === "good") {
        return "Good 😃"
      }
      if (this.post.day_type === "okay") {
        return "Okay 🙂"
      }
      if (this.post.day_type === "bad") {
        return "Bad 😟"
      }
      if (this.post.day_type === "angry") {
        return "Angry 😠"
      } else {
        return this.post.day_type
      }
    },
  },

  data() {
    return {
      isImageUploading: false,
      loc: {
        lat: null,
        lon: null,
      },
      showWritable: true,
      post: {},
      pagination: {
        page_num: this.currentPage,
        page_size: this.limit,
        total_count: 0,
      },
      fileList: [],
      previewImage: false,
      previewVisible: false,
      comments: [],
      comment: "",
      comment_attach: [],
      currentPage: 1,
      limit: 2,
      reactions: {
        hugs: false,
        likes: false,
        // favorites: false,
        flag: false,
        haha: false,
        emotional: false,
        angry: false,
      },
      pack: packData,
      displayDots: false,
      showRemoveCircleOption: true,
      posting: false,
      displayDeleteDots: false,
      currentClickedReaction: null,
      emojiVisible: false,
      loadingScreen: false,
      postSaved: null,
    }
  },

  async created() {
    this.post = this.postData
    const MIRROR_REACTION_TYPES = {
      1: "embrace",
      2: "like",
      8: "happy",
      9: "emotional",
      10: "angry",
    }
    const reaction_ids = [1, 2, 8, 9, 10]
    // this.currentClickedReaction = this.post.my_reaction.length
    //   ? MIRROR_REACTION_TYPES[this.post.my_reaction[0].reaction_type]
    //   : null;
    const oldReact = this.post.my_reaction.find(eachR => reaction_ids.includes(eachR.reaction_type))
    this.currentClickedReaction = this.post.my_reaction.length && oldReact ? MIRROR_REACTION_TYPES[oldReact.reaction_type] : null
    console.log(this.post.post_title, this.post.post_text, "Post.vue ->", this.post)
    this.post.my_reaction.forEach(r => {
      r.reaction_type === 4 && (this.postSaved = true)
    })

    // this.reactions.hugs = !!this.getReaction(1).length;
    // this.reactions.likes = !!this.getReaction(2).length;
    // this.reactions.favorites = !!this.getReaction(4).length;
    // this.reactions.flag = !!this.getReaction(5).length;
    // console.log("this.post.reaction ==", this.post.reaction);
    // console.log("this.reactions ==", this.reactions); // this has the reactions from the post
    eventBus.$on("flag-post", data => {
      if (data.id === this.post.id) {
        this.post.is_spam = true
      }
    })
    this.fetchComments(true, 1)
    console.log("comments ->", this.comments)
    console.log("pagination ->", this.pagination)
    this.loc = await this.getLocation()
  },

  methods: {
    removeCommentFromDisplay(cid) {
      this.comments = this.comments.filter(c => c.id !== cid)
    },
    closeEmoji(e) {
      this.emojiVisible = false
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible
    },
    insert(emoji) {
      this.comment += emoji
    },
    handleReactionsClick(emoji) {
      if (this.currentClickedReaction !== emoji) {
        this.currentClickedReaction = emoji
      } else {
        this.currentClickedReaction = null
      }
    },
    getTopThreeReactions() {
      // console.log(this.post.reaction);
      // const sortedReactions = Object.keys(this.post.reaction).sort(
      //   (a, b) => this.post.reaction[a] - this.post.reaction[b]
      // );
      // console.log(sortedReactions.slice(0, 3));
      return ["happy", "embrace", "like"]
    },
    getTotalReactions() {
      console.log("getTotalReactions -> post.reaction ->", this.post.reaction)
      let value = 0
      const reacts = ["angry", "sad", "happy", "likes", "hugs"]
      reacts.forEach(key => (value = value + this.post.reaction[key]))
      // if (value === 0) {
      //   this.currentClickedReaction = null;
      // }
      return value || 0
    },
    handleCloseAll(value = true) {
      // console.log("handleCloseAll");
      this.displayDots = false
      this.displayDeleteDots = false
    },
    handleDisplayDeleteDots(e) {
      console.log("handleDisplayDeleteDots")
      e.preventDefault()
      this.displayDeleteDots = !this.displayDeleteDots
    },
    handleDeletePostModal(e, post) {
      e.preventDefault()
      this.displayDeleteDots = false
      this.$refs.deletePostModal.show(post)
    },
    active() {
      return "active"
    },
    showModel(post) {
      this.$refs.reportContentModal.show(post, 1)
      this.displayDots = false
    },

    fetchUser(e) {
      if (this.displayDots) {
        this.displayDots = false
      } else {
        // this.displayDots = true;
        this.loadingScreen = true
        console.log("inside fetchUser")
        e.preventDefault()
        // this.handleCloseAll(false); // ??
        // console.log("this.post.user[0] ==", this.post.user[0]);
        const user = this.post.user[0]

        if (user.role === "admin") {
          // ??
          // console.log("user role is admin");
          setTimeout(() => {
            this.displayDots = !this.displayDots
            this.showRemoveCircleOption = false
            this.loadingScreen = false
          }, 100)
        } else {
          UserRepository.getOtherUserProfile(user, this.currentCircle.id).then(res => {
            const onCircle = res.data.data.on_circle
            console.log("res.data.data.on_circle ==", res.data.data.on_circle)
            this.loadingScreen = false
            if (!onCircle) {
              this.displayDots = !this.displayDots
              this.showRemoveCircleOption = false
            } else {
              this.displayDots = !this.displayDots
            }
          })
        }
      }
    },

    /**
     * Get the location of the user using Geolocation
     */
    getLocation() {
      return new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(pos => {
          const lat = pos.coords.latitude
          const lon = pos.coords.longitude
          resolve({ lat, lon })
        })
      })
    },

    /**
     * Fetch comments
     *
     * @param {Object} post
     */
    fetchComments(append = false, commentsLimit = 1) {
      this.showWritable = true
      PostRepository.fetchPostComments(
        this.post.id,
        this.currentPage,
        // this.limit
        commentsLimit
      )
        .then(res => {
          if (append) {
            this.comments.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.comments = res.data.data.data
              this.pagination = res.data.data.paginator
            }
          }
          console.log("comments ->", this.comments)
          this.currentPage += 1
          // this.showWritable = true;
        })
        .catch(err => {})
    },

    // Comment on a post
    postFunction() {
      this.posting = true
      const payload = {
        post_parent_id: this.post.id,
        comment_text: this.comment,
        user: this.authUser.user.id,
        comment_attach: this.comment_attach.length ? this.comment_attach : null,
        commented_on_type: 1,
        commented_on_id: this.post.id,
        latlong: this.loc.lat && this.loc.lon ? { lat: this.loc.lat, lon: this.loc.lon } : null,
      }
      PostRepository.postComment(payload, this.currentCircle.id)
        .then(res => {
          this.posting = false
          this.comment = ""
          this.currentPage = 1
          // this.post.comments_count += 1;
          this.$store.commit("Posts/addCommentCount", this.post.id)
          this.comment_attach = []
          this.$refs.fileInput.value = ""
          this.fileList = []
          this.emojiVisible = false
          this.previewImage = false
          this.previewVisible = false
          this.comments = []
          this.fetchComments()
        })
        .catch(err => {
          this.posting = false
        })
    },
    postComment() {
      if (this.comment.trim().length) {
        this.postFunction()
      }
      if (this.comment_attach.length > 0 && this.comment.trim().length === 0) {
        this.postFunction()
      }
    },

    /**
     * Remove User form Circle
     */
    removeUserFromCircle() {
      UserRepository.removeFromCircle(this.post.user[0], this.currentCircle.id)
        .then(res => {
          this.displayDots = false
          eventBus.$emit("on-circle")
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: "Cannot remove from user",
          })
        })
    },

    /**
     * Handle image Upload
     */
    async handlePicUpload() {
      const file = this.$refs.fileInput.files[0]
      this.isImageUploading = true
      try {
        if (file.size / (1024 * 1024) > 1) {
          this.$notification.error({
            message: "Error",
            description: "File size exceeds 1MB limit",
          })
          const input = this.$refs.file
          input.type = "text"
          input.type = "file"
          this.isImageUploading = false
        }
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          this.isImageUploading = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        const fileName = urlData.data.data.filename[0]
        await s3Upload(urlData.data.data.url[0], file)
        // this.comment_attach = [fileName]
        this.comment_attach.push(fileName)
        const fileListData = {
          uid: this.comment_attach.length,
          name: file.name,
          status: "done",
          url: urlData.data.data.preview_url,
        }
        this.loading = false
        this.fileList.push(fileListData)
        this.isImageUploading = false
      } catch (err) {}
      this.isImageUploading = false
    },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    async handleChange(data) {
      console.log(data, "filelist data")
      this.fileList.length === 1 ? (this.fileList = []) : this.fileList.splice(data.file.uid - 1, 1)
      this.comment_attach.splice(data.file.uid - 1, 1)
    },

    getPostImage() {
      console.log("post", this.post)
      if (this.post.sponsered) {
        return `${this.post.sponsered[0].url}`
      } else {
        return `${this.post.user[0].url}`
      }
    },

    /**
     * Get reaction of a given type
     *
     * @param {Integer} type
     */
    getReaction(type) {
      let status = []
      status = this.post.my_reaction.filter(reaction => {
        return reaction.reaction_type === type && reaction.user === this.authUser.user.id
      })
      return status
    },

    /**
     * Reaction to any post/comment. Based on the reaction, send required payload.
     *
     * @param {Object} post
     * @param {Object} event
     */
    react(entity, event, comment = false) {
      console.log("react() -> post.reaction ->", this.post.reaction)
      // if (this.post.user[0].id === this.authUser.user.id) {
      //   return
      // }

      if (this.posting) {
        return
      }
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
       */
      // let path = event.path || (event.composedPath && event.composedPath());
      // console.log("path ==", path);

      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5,
        HAHA: 8,
        EMOTIONAL: 9,
        ANGRY: 10,
      }

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
        poll: 5,
      }

      // const type = event.target.id ? event.target.id : path[1]["id"];
      const type = this.currentClickedReaction

      // switch (type) {
      //   case "embrace":
      //   case "hug":
      //   case "hugs":
      //     this.reactions.hugs
      //       ? this.deleteReaction(REACTION_TYPES.HUGS, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.HUGS,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "likes":
      //   case "like":
      //     this.reactions.likes
      //       ? this.deleteReaction(REACTION_TYPES.LIKE, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.LIKE,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "haha":
      //   case "happy":
      //     this.reactions.haha
      //       ? this.deleteReaction(REACTION_TYPES.HAHA, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.HAHA,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "angry":
      //   case "mad":
      //     this.reactions.angry
      //       ? this.deleteReaction(REACTION_TYPES.ANGRY, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.ANGRY,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "sad":
      //   case "emotional":
      //     this.reactions.emotional
      //       ? this.deleteReaction(REACTION_TYPES.EMOTIONAL, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.EMOTIONAL,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   // case "favorites":
      //   //   this.reactions.favorites
      //   //     ? this.deleteReaction(REACTION_TYPES.FAVORITE, type)
      //   //     : this.saveReaction(
      //   //         entity.id,
      //   //         REACTION_TYPES.FAVORITE,
      //   //         comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //   //       );
      //   //   break;

      //   case "flag":
      //     this.reactions.flag
      //       ? this.deleteReaction(REACTION_TYPES.FLAGED, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.FLAGED,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   default:
      //     break;
      // }
      switch (type) {
        case "embrace":
        case "hug":
        case "hugs":
          this.saveReaction(entity.id, REACTION_TYPES.HUGS, comment ? REACTION_ON.COMMENT : REACTION_ON.POST)
          break

        case "likes":
        case "like":
          this.saveReaction(entity.id, REACTION_TYPES.LIKE, comment ? REACTION_ON.COMMENT : REACTION_ON.POST)
          break

        case "haha":
        case "happy":
          this.saveReaction(entity.id, REACTION_TYPES.HAHA, comment ? REACTION_ON.COMMENT : REACTION_ON.POST)
          break

        case "angry":
        case "mad":
          this.saveReaction(entity.id, REACTION_TYPES.ANGRY, comment ? REACTION_ON.COMMENT : REACTION_ON.POST)
          break

        case "sad":
        case "emotional":
          this.saveReaction(entity.id, REACTION_TYPES.EMOTIONAL, comment ? REACTION_ON.COMMENT : REACTION_ON.POST)
          break

        default:
          console.log("react() - default")
          this.posting = true
          const headers = {
            Authorization: `Bearer ${this.authUser.user.token}`,
          }
          this.$http
            .get(`${process.env.BASE_API_URL}/reactions/?reacted_on_id=${this.post.id}&circle_id=${this.currentCircle.id}&user_id=${this.authUser.user.id}`, { headers })
            .then(res => {
              console.log("default - get - response ->", res.data.data[0])

              this.deleteCurrentReaction(res.data.data[0].id, this.post.id, res.data.data[0].reaction_type, null, res.data.data[0].reaction_type)
            })
            .catch(err => {
              this.posting = false
              this.$notification.error({
                message: "Error",
                description: "Reaction could not be fetched",
              })
            })
          break
      }
    },

    /**
     * Delete reaction to post
     *
     * @param {Integer} reactionId
     */
    deleteReaction(reactionId, type) {
      this.posting = true
      const reactions = this.getReaction(reactionId)
      console.log("reactions inside deleteReaction ==", reactions)
      let ids = ""
      ids = reactions.map(reaction => {
        return reaction.id
      })
      // const currentCircle = JSON.parse(localStorage.getItem('currentCircle'))
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      this.reactions[type] = false
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`, { headers })
        .then(res => {
          this.reactions[type] = false
          this.posting = false
          console.log("delete")
          const deletePayload = { reactions, type }
          this.$store.commit("Posts/deletePostReactions", deletePayload)
        })
        .catch(err => {
          this.posting = false
        })
    },

    deleteCurrentReaction(idToDelete, postId, reactionType, reactionOnType, oldReaction) {
      console.log("inside deleteCurrentReaction()")
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      }
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${idToDelete}`, {
          headers,
        })
        .then(res => {
          this.reactions[MIRROR_REACTION_TYPES[oldReaction]] = false
          this.post.reaction[MIRROR_REACTION_TYPES[oldReaction]] -= 1
          // console.log("saveReacton - delete - response ->", res.data);
          console.log("oldReaction ->", oldReaction)
          console.log("MIRROR_REACTION_TYPES[oldReaction] ->", MIRROR_REACTION_TYPES[oldReaction])
          console.log("reactionType ->", reactionType)
          console.log("MIRROR_REACTION_TYPES[reactionType] ->", MIRROR_REACTION_TYPES[reactionType])
          if (MIRROR_REACTION_TYPES[oldReaction] !== MIRROR_REACTION_TYPES[reactionType]) {
            console.log("inside deleteCurrentReaction() - IF")

            this.saveNewReaction(postId, reactionType, reactionOnType)
          } else {
            console.log("inside deleteCurrentReaction() - ELSE")

            console.log(eval(`this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users`))
            // eval(
            //   `this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users`
            // ) = eval(
            //   `this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users`
            // ).filter(user => {
            //   return user.id !== this.authUser.user.id;
            // });
            eval(
              `this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users = 
                  this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users
                    .filter(user => {
                      return user.id !== this.authUser.user.id;
                    })`
            )
            console.log(eval(`this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users`))
            this.posting = false
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: "Reaction could not be deleted",
          })
        })
    },

    /**
     * Save reaction to post
     *
     * @param {Integer} postId
     * @param {Integer} reactionType
     * @param {Integer} reactionOnType
     */
    saveReaction(postId, reactionType, reactionOnType) {
      console.log("inside saveReaction() ->", this.post.reaction)
      this.posting = true
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }

      if (this.post.my_reaction.length) {
        this.$http
          .get(`${process.env.BASE_API_URL}/reactions/?reacted_on_id=${postId}&circle_id=${this.currentCircle.id}&user_id=${this.authUser.user.id}`, { headers })
          .then(res => {
            console.log("saveReacton - get - response ->", res.data.data[0])

            this.deleteCurrentReaction(res.data.data[0].id, postId, reactionType, reactionOnType, res.data.data[0].reaction_type)
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Reaction could not be fetched",
            })
          })
      } else {
        this.saveNewReaction(postId, reactionType, reactionOnType)
      }
    },

    saveNewReaction(postId, reactionType, reactionOnType) {
      console.log("inside saveNewReaction() ->", this.post.reaction)
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      }
      const payload = {
        reacted_on_type: reactionOnType,
        reacted_on_id: postId,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      }
      this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          // this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
          const editPayload = {
            MIRROR_REACTION_TYPES,
            reactionType,
            response: res.data.data,
          }

          // this.$store.commit("Posts/editPostReactions", editPayload); // commented to test

          // this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1;
          // const index = this.post.my_reaction.findIndex(
          //   rs => rs.reaction_type === reactionType
          // );
          // if (index >= 0) {
          //   this.post.my_reaction.splice(index, 1);
          // }
          // this.post.my_reaction.push(res.data.data);
          // location.reload();

          // dovemedpost/?id=${postId}&circle_id=${circleId}&page_num=1&items=1
          const headers = {
            Authorization: `Bearer ${this.authUser.user.token}`,
          }
          this.$http
            .get(`${process.env.BASE_API_URL}/dovemedpost/?id=${postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`, { headers })
            .then(res => {
              console.log("updated post data ->", res.data.data.data[0])
              console.log("new reaction ->", MIRROR_REACTION_TYPES[reactionType])
              this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1

              // updating new reactions
              this.post.hugs_reacted_users = res.data.data.data[0].hugs_reacted_users
              this.post.happy_reacted_users = res.data.data.data[0].happy_reacted_users
              this.post.sad_reacted_users = res.data.data.data[0].sad_reacted_users
              this.post.likes_reacted_users = res.data.data.data[0].likes_reacted_users
              this.post.angry_reacted_users = res.data.data.data[0].angry_reacted_users
              this.post.my_reaction = res.data.data.data[0].my_reaction

              this.posting = false
            })
            .catch(err => {
              this.$notification.error({
                message: "Error",
                description: "Reacted users cannot be fetched",
              })
              this.posting = false
            })
        })
        .catch(err => {
          this.posting = false
        })
    },

    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },

    getInitials() {
      const f = this.authUser.user.first_name
        ? this.authUser.user.first_name[0].toUpperCase()
        : this.authUser.user.display_name
        ? this.authUser.user.display_name[0].toUpperCase()
        : this.authUser.user.email
        ? this.authUser.user.email[0].toUpperCase()
        : ""
      const l = this.authUser.user.last_name ? this.authUser.user.last_name[0].toUpperCase() : ""
      return f + l
    },

    viewProfile() {
      this.loadingScreen = true
      const user = this.post.user[0]
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: "caregiver" },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
    },

    savePost() {
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      if (!this.postSaved) {
        PostRepository.saveReaction(this.currentCircle.id, {
          reacted_on_type: 1,
          reacted_on_id: this.post.id,
          user: this.authUser.user.id,
          user_role: this.authUser.user.role || "",
          reaction_type: 4,
        })
          .then(res => {
            this.postSaved = true
            // save the id
            console.log(res.data)
            console.log(res.data && res.data.data)
            this.post.my_reaction.push(res.data.data)
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Post cannot be saved",
            })
          })
      } else {
        // console.log(this.post.my_reaction);
        const saveId = this.post.my_reaction.filter(r => r.reaction_type === 4)[0].id
        this.$http
          .delete(`${process.env.BASE_API_URL}/reactions/?ids=${saveId}`, {
            headers,
          })
          .then(res => {
            this.postSaved = false
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Post cannot be unsaved",
            })
          })
      }
    },
  },
}
</script>

<style lang="scss">
.hw20 {
  height: 20px;
  width: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: -3px;
}

.showReactions {
  position: relative;
}

.emojiReactions {
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  transform: translateY(30px);
  transition: all 1s;
  position: absolute;
  top: -60px;
  left: -20px;
}

.showReactions:hover .emojiReactions,
.emojiReactions:hover {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateY(0);
}

.dot-menu-cont {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  // height: 50%;
}

.fa-camera {
  width: 35px;
  height: 35px;
  position: relative;
  vertical-align: text-top;
  cursor: pointer;
}
.camera-icon-inp {
  opacity: 0;
  position: absolute;
  right: 55px;
  top: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 5;
  &::-webkit-file-upload-button {
    opacity: 0;
    position: absolute;
    right: 55px;
    top: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 5;
  }
}
.sub-text {
  font-size: 16px !important;
}
.image-uploading {
  height: auto;
  margin: 20px;
  display: flex;
  flex-wrap: wrap;
}
.post-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.post__tags {
  margin-bottom: 20px;
  // margin: 10px;
  display: flex;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    margin-right: 5px;
    line-height: 1.5;
    // margin: 5px;
  }
  .popover-button {
    // margin: 5px;
    line-height: 1em;

    button {
      background: none;
      border: none;
    }
  }
}
.promoted-post-head {
  padding: 8px 16px;
  display: flex;
  border-radius: 8px 8px 0px 0px;
  align-items: center;
  font-size: 10px;
  // line-height: 12px;
  font-weight: 700;

  div:first-child {
    transform: scale(0.1);
    width: 40px;
  }

  div:last-child {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
}

.delete-post-dropdown {
  position: absolute;
  right: 0px;
}
.dropdown-text {
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  color: #333333;
  line-height: 24px;
}
.shadow-card {
  .posted-reactions-text {
    // width: 120px !important;
    text-align: left !important;
    padding-right: 0 !important;
  }
}
// .fw700 {
//   font-weight: 700 !important;
// }
// .font12 {
//   font-size: 12px !important;
// }
// .font14 {
//   font-size: 14px !important;
// }
.card-item {
  font-weight: 400 !important;
}
.width30 {
  width: 30px;
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  // z-index: 999;
}
.u-options div {
  padding-left: 6px !important;
}
.card-item:hover,
.dropdown-text:hover {
  background: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/PostDoctor.vue